/*
  The picture above an empty state.

  Only on the four screens that can be genuinely blank, and only where the art means
  something. An illustration that does not say what the screen is for is decoration, and a
  decorated empty screen is still an empty screen.

  The art is the landing page's, recoloured. Those files were drawn for this product's own
  subject matter and then only ever shown to people who had not signed up, which is the
  wrong way round: the person who most needs to be told what File Cabinet is for is the
  owner looking at an empty one.

  Recoloured rather than reused, because the originals carry #0B2545 and #D4AF37, a navy
  and a gold the app no longer has. They are separate files so the signed-out page keeps
  its own palette until it is repainted; when it is, the two sets converge and one should
  go. See docs in CLAUDE.md.

  aria-hidden throughout. The title and copy underneath already say it, and a screen reader
  announcing "illustration of a filing cabinet" before them adds nothing.
*/
export function EmptyArt({ name }: { name: 'archive' | 'followup' | 'sessions' }) {
  const src = `/illustrations/empty-${name}.webp`
  return (
    <img
      className="empty__art"
      src={src}
      srcSet={`${src} 1x, /illustrations/empty-${name}@2x.webp 2x`}
      alt=""
      aria-hidden
      loading="lazy"
      decoding="async"
    />
  )
}
